<script setup lang="ts">
import Toast from 'primevue/toast';
import { useAuthUser, useSession } from './helpers/globals';
import AuthRootView from './views/auth/AuthRootView.vue';
import GuestRootView from './views/guest/GuestRootView.vue';
import { AuthLevel } from './helpers/auth';
const user = useAuthUser();
const session = useSession();
</script>

<template>
    <Toast position="top-center"></Toast>
    <AuthRootView v-if="user && session.authLevel === AuthLevel.AUTH_COMPLETE"></AuthRootView>
    <GuestRootView v-else></GuestRootView>
</template>
